(function($, undefined) {
	'use strict';

	var init = function() {
		wrapImages();
		wrapTables();
		wrapYoutubeIframes();
	};

	var wrapImages = function() {
		$('.com-content__content_rich-text').each(function(i, el) {
			var ctn = $(el);
			var imgs = $('img', ctn);
			imgs.each(function(i, el) {
				var img = $(el);
				if (img.closest('.com-content__img-container').length === 0) {
					img.wrap("<div class='com-content__img-container'></div>");
				}
			});
		});
	};
	var wrapTables = function() {
		$('.com-content__content_rich-text').each(function(i, el) {
			var ctn = $(el);
			var tables = $('table', ctn);
			tables.each(function(i, el) {
				var table = $(el);
				if (table.closest('.com-content__table-container').length === 0) {
					table.wrap("<div class='com-content__table-container'></div>");
				}
			});
		});
	};

	var wrapYoutubeIframes = function() {
		$('.com-content__content_rich-text').each(function(i, el) {
			var ctn = $(el);
			var ytIframes = $('iframe[src*=youtube]', ctn);
			ytIframes.each(function(i, el) {
				var iframe = $(el);
				if (iframe.closest('.com-content__yt-iframe-container').length === 0) {
					iframe.wrap("<div class='com-content__yt-iframe-container'></div>");
				}
			});
		});
	};

	$(window).ready(function() {
		init();
	});
})(jQuery);
